module.exports = __webpack_public_path__ + "static/cely_rose_grossesse_4-a3b526c8c889bb9b57260a69bd964e68.jpg";